export const STORE_UI = 'uiStore'
export const STORE_AUTH = 'authStore'
